import { useState } from "react";

import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

import "./style.css";

function PayPalCheckout({ setModal, cart, customerInfo }) {
    const [paymentId, setPaymentId] = useState(undefined);

    const initialOptions = {
        "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
        currency: "EUR",
        intent: "capture"
    };

    const createOrder = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/payements/create-paypal-order`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ cart, customerInfo }),
            });
            const data = await response.json();

            if (!data.orderID) throw new Error('No orderID received from server');
            setPaymentId(data.paymentId);
            return data.orderID;
        }
        catch (error) {
            console.error('Error creating PayPal order:', error);
            throw error;
        }
    };

    const onApprove = async (data) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/payements/capture-paypal-order`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ orderID: data.orderID, paymentId }),
            });
            const result = await response.json();

            setPaymentId(undefined);
            if (result.status === 'success') setModal('success');
        }
        catch (error) {
            console.error('Error capturing PayPal order:', error);
        }
    };

    const onCancel = () => {
        console.log('PayPal payment cancelled');
    };

    const onError = (err) => {
        console.error('PayPal error:', err);
    };

    return (
        <PayPalScriptProvider options={initialOptions}>
            <div className="paypal-checkout">
                <PayPalButtons
                    style={{
                        layout: 'horizontal',
                        color: 'silver',
                        shape: 'rect',
                        label: 'paypal',
                        height: 55
                    }}
                    createOrder={createOrder}
                    onApprove={onApprove}
                    onCancel={onCancel}
                    onError={onError}
                />
            </div>
        </PayPalScriptProvider>
    );
}

export default PayPalCheckout;